import { LocationCardsProps } from '@ahc-digital/component-library';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { getDroplink } from 'src/shared/param-utils';
import { LOCATION_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C24LocationCardsProps } from './C24LocationCards.types';

export function CreateLocationCardsModel(props?: C24LocationCardsProps) {
  const { fields, params, rendering } = props || {};
  const { renderText, renderRichText, renderLink } = useConditionalRendering();
  return {
    backgroundColor: getDroplink(params?.BackgroundColor, 'white'),
    contentAlignment: getDroplink(params?.ContentAlignments, 'center'),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    numberOfColumns: getDroplink(params?.NumberOfColumns, '3'),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    ctaAlignment: getDroplink(params?.CTAAlignment, 'center'),
    cta: renderLink(fields?.CTA) as LocationCardsProps['cta'],
    ctaStyle: getDroplink(params?.CTAStyle, 'solid'),
    secondCta: renderLink(fields?.SecondCTA) as LocationCardsProps['secondCta'],
    secondCtaStyle: getDroplink(params?.SecondCTAStyle, 'link'),
    children: rendering && <Placeholder name={LOCATION_CARDS} rendering={rendering} />,
  };
}
